"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "App", {
  enumerable: true,
  get: function get() {
    return _components.App;
  }
});
Object.defineProperty(exports, "AppReact", {
  enumerable: true,
  get: function get() {
    return _components.AppReact;
  }
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function get() {
    return _components.Footer;
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _components.Header;
  }
});
exports.ReduxApp = void 0;
Object.defineProperty(exports, "Spinner", {
  enumerable: true,
  get: function get() {
    return _components.default;
  }
});
Object.defineProperty(exports, "Title", {
  enumerable: true,
  get: function get() {
    return _components.Title;
  }
});
Object.defineProperty(exports, "ToolTipReact", {
  enumerable: true,
  get: function get() {
    return _components.ToolTipReact;
  }
});
Object.defineProperty(exports, "getStore", {
  enumerable: true,
  get: function get() {
    return _store.getStore;
  }
});
exports.renderReactComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactRedux = require("react-redux");
var _store = require("./store");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = _interopRequireWildcard(require("./components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ReduxApp = function ReduxApp(_ref) {
  var store = _ref.store,
    siteConfig = _ref.siteConfig;
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react.default.createElement(_components.App, null));
};
exports.ReduxApp = ReduxApp;
var renderReactComponent = function renderReactComponent(container, props) {
  if (props.siteInfo && props.siteInfo.redux) {
    var siteConfigFn = function siteConfigFn() {
      return props.siteInfo;
    };
    var store = (0, _store.getStore)({}, siteConfigFn);
    _reactDom.default.render(ReduxApp({
      store: store
    }), container);
  } else {
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_components.AppReact, props), container);
  }
};
exports.renderReactComponent = renderReactComponent;
ReduxApp.propTypes = {
  store: _propTypes.default.object.isRequired,
  siteConfig: _propTypes.default.object
};
